import PropTypes from "prop-types";
import React, { useState, useRef, useEffect } from "react";
import { getPhoenixFormVersion } from "requests/homeowner/caseforms";
import MSpinner from "components/Shared/MSpinner.tsx";
import Appraisal1004pV0 from "components/Homeowner/CaseForms/Appraisal1004P/V0/Appraisal1004pV0";
import Appraisal1004pV1 from "components/Homeowner/CaseForms/Appraisal1004P/V1/Appraisal1004pV1";
import Appraisal1004pV2 from "components/Homeowner/CaseForms/Appraisal1004P/V2/Appraisal1004pV2";

export const Appraisal1004p = props => {
  const mounted = useRef(true);

  const [version, setVersion] = useState(0);
  const [isFetchingVersion, setIsFetchingVersion] = useState(true);

  useEffect(() => {
    getPhoenixFormVersion(props.controlNumber, (payload) => {
      setVersion(payload);
      setIsFetchingVersion(false);
    }, mounted);
    return (() => { mounted.current = false; });
  }, []);

  if (isFetchingVersion) return <MSpinner />;

  let versionedComponents = [];
  // The 4 is here just in case someone switches a case from the 1004 Hybrid/70H form to the 1004P form
  versionedComponents[0] = Appraisal1004pV0;
  versionedComponents[1] = Appraisal1004pV1;
  versionedComponents[2] = Appraisal1004pV2;
  versionedComponents[4] = Appraisal1004pV1;
  versionedComponents["0"] = Appraisal1004pV0;
  versionedComponents["1"] = Appraisal1004pV1;
  versionedComponents["2"] = Appraisal1004pV2;
  versionedComponents["4"] = Appraisal1004pV1;
  versionedComponents["PhoenixFormVersionNoneFound"] = Appraisal1004pV0;
  let MyComponent = versionedComponents[version];
  if (!MyComponent) {
    throw new Error(`No corresponding 1004p frontend version for backend version: ${version}`);
  }
  return (<MyComponent
    controlNumber={props.controlNumber}
    onChange={props.onChange}
    onSave={props.onSave}
    readOnly={props.readOnly}
  />);
};

Appraisal1004p.propTypes = {
  controlNumber: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default Appraisal1004p;
